import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {Router} from "@angular/router";

@Directive({
  selector: '[can]'
})
export class AclDirective {
  private permission!: string;
  private permissionType!: string;
  private notPermission!: string;
  private readonly aclPermissions: string[] = [];

  @Input()
  public set can(value: { permission: string, permissionType: string }) {
    //if null, then the user has access to the page
    if (value.permission === null) {
      this.allow();
      return;
    }
    this.permission = value.permission;
    this.permissionType = value.permissionType;
    this.evaluate();
  }


  @Input()
  public set cannot(value: string) {
    this.notPermission = value;
    this.evaluate();
  }

  private created = false;
  private elseCreated = false;

  constructor(
    private template: TemplateRef<any>,
    private view: ViewContainerRef,
    private router: Router
  ) {
    this.aclPermissions=JSON.parse(localStorage.getItem('aclPermissions') || '[]');
  }

  private evaluate(): void {
    let acl = this.aclPermissions;
    const isAllowed = acl.includes(this.permission)
      && (this.notPermission == null || !acl.includes(this.notPermission));

    if (this.permissionType === 'page' && !isAllowed) {
      // redirect to the unauthorized page
      this.router.navigate(['/dashboard/unauthorized']);
    } else if (isAllowed) {
      this.allow();
    } else {
      this.disallow();
    }
  }

  private allow(): void {
    if (this.created) {
      return;
    }
    this.view.clear();
    this.view.createEmbeddedView(this.template);
    this.created = true;
  }

  private disallow(): void {
    if (!this.created) {
      return;
    }
    this.view.clear();
    this.created = false;

    if (this.permissionType === 'button') {
      // hide the button
      const button = this.template.elementRef.nativeElement;
      button.style.display = 'none';
    }
  }
}
